<template>
  <div>
    <DialogContainer v-model="dialogObj">
      <template v-slot:dialogSlot>
        <div class="role-body custom-form">
          <el-button type="primary" icon="el-icon-plus" style="margin-bottom: 0.2rem" @click="handleAdd">
            添加字典
          </el-button>
          <custom-table
            :data="tableData"
            :column="tableColumn"
            :loading="tableOptions.loading"
            :selection="false"
            :show-search-box="false"
            :show-pagination="false"
            class="custom-table-box">
            <template v-slot:dictSort="{ row }">
              <span>{{ row.dictSort }}</span>
            </template>
            <template v-slot:operation="{ row }">
              <span class="operate-btn" @click.stop="handleEdit(row)">编辑</span>
              <span class="operate-btn" @click.stop="handleDelete(row.dictDataId)">删除</span>
            </template>
          </custom-table>
        </div>
      </template>
    </DialogContainer>
    <dict-item-add-or-edit ref="dictItemAddOrEdit"></dict-item-add-or-edit>
  </div>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import dictItemAddOrEdit from "./dictItemAddOrEdit.vue";
import customTable from "@/components/CustomTable.vue";
import { deleteDictInfo, getDictPage } from "./api";
export default {
  name: "DictItem",
  components: {
    DialogContainer,
    customTable,
    dictItemAddOrEdit,
  },
  data() {
    return {
      dictType: "",
      dialogObj: {
        loading: false,
        btnLoading: false,
        show: false,
        title: "字典管理",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.tableData = [];
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      tableData: [],
      tableOptions: {
        loading: false,
      },
      tableColumn: [
        {
          label: "字典名称",
          prop: "dictLabel",
          show: true,
        },
        {
          label: "字典编号",
          prop: "dictCode",
          show: true,
        },
        {
          label: "序号",
          prop: "dictSort",
          scopeStatus: true,
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "250px",
          scopeStatus: true,
          show: true,
        },
      ],
    };
  },
  methods: {
    handleAdd() {
      this.$refs.dictItemAddOrEdit.init(this.dictType);
    },
    handleEdit(row) {
      this.$refs.dictItemAddOrEdit.init(this.dictType, row);
    },
    init(row) {
      this.dictType = row.dictType;
      this.getTableData();
      this.dialogObj.show = true;
    },
    getTableData() {
      this.tableOptions.loading = true;
      getDictPage(this.dictType)
        .then((res) => {
          this.tableOptions.loading = false;
          if (res.code === 200) {
            this.tableData = res.data;
          }
        })
        .catch(() => {
          this.tableOptions.loading = false;
        });
    },
    handleDelete(id) {
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        deleteDictInfo(id).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getTableData();
          } else {
            this.$message.error("删除失败");
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.role-body {
  box-sizing: border-box;
}
</style>
